// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-cv-js": () => import("./../../../src/pages/cv.js" /* webpackChunkName: "component---src-pages-cv-js" */),
  "component---src-pages-eleusis-js": () => import("./../../../src/pages/eleusis.js" /* webpackChunkName: "component---src-pages-eleusis-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-portfolio-dla-js": () => import("./../../../src/pages/portfolio/dla.js" /* webpackChunkName: "component---src-pages-portfolio-dla-js" */),
  "component---src-pages-portfolio-main-js": () => import("./../../../src/pages/portfolio/main.js" /* webpackChunkName: "component---src-pages-portfolio-main-js" */),
  "component---src-pages-portfolio-test-js": () => import("./../../../src/pages/portfolio/test.js" /* webpackChunkName: "component---src-pages-portfolio-test-js" */)
}

